//https://blog.bitsrc.io/angular-route-reuse-strategy-c7939ebbf797

import { Injectable } from '@angular/core';
import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

@Injectable()
export class AppRouteReuseStrategy implements RouteReuseStrategy {
  private routeStore = new Map<string, DetachedRouteHandle>();

  //should the component be stored?
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return route?.data['reuse'] && !this.hasQueryParams(route);
  }

  //store the component if shouldDetach returns true
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    this.routeStore.set(route.data['key'], handle);
  }

  //return true if route should be reused and is already stored
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const path = route.data['key'];
    return route?.data['reuse'] && !this.hasQueryParams(route) && !!this.routeStore.get(path);
  }

  //return the detachedRoutehandle if shouldAttach returns true
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    const path = route.data['key'];
    return this.routeStore.get(path);
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  private hasQueryParams(route: ActivatedRouteSnapshot): boolean {
    return !!Object.keys(route.queryParams).length;
  }
}
